import { useState } from "react";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import GolfCourseRoundedIcon from "@mui/icons-material/GolfCourseRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const NOTICE_START = Date.parse("2026-08-25T00:00:00+09:00");
const NOTICE_END_EXCLUSIVE = Date.parse("2026-09-01T00:00:00+09:00");
const NOTICE_ACKNOWLEDGED_DATE_KEY = "community:golf-renewal-notice-acknowledged-date";

export const isGolfRenewalNoticeVisible = (now = new Date()) => {
  const timestamp = now.getTime();
  return timestamp >= NOTICE_START && timestamp < NOTICE_END_EXCLUSIVE;
};

const getKstDateKey = (now = new Date()) => new Date(now.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);

const isGolfRenewalNoticeAcknowledgedToday = (now = new Date()) => {
  try {
    return window.localStorage.getItem(NOTICE_ACKNOWLEDGED_DATE_KEY) === getKstDateKey(now);
  } catch {
    return false;
  }
};

const GolfRenewalNoticeDialog = () => {
  const [isOpen, setIsOpen] = useState(() => isGolfRenewalNoticeVisible() && !isGolfRenewalNoticeAcknowledgedToday());

  const handleConfirm = () => {
    try {
      window.localStorage.setItem(NOTICE_ACKNOWLEDGED_DATE_KEY, getKstDateKey());
    } finally {
      setIsOpen(false);
    }
  };

  if (!isOpen) return null;

  return (
    <Dialog
      aria-labelledby="golf-renewal-notice-title"
      className="hp-dialog hp-golf-notice-dialog"
      open
      onClose={() => setIsOpen(false)}
      PaperProps={{ className: "hp-dialog__paper hp-golf-notice-dialog__paper" }}
    >
      <DialogTitle id="golf-renewal-notice-title">
        <span className="hp-golf-notice-dialog__title">9월 골프연습장 새 단장 안내</span>
        <span className="hp-golf-notice-dialog__subtitle">더 편리한 골프연습장으로 준비하고 있습니다.</span>
      </DialogTitle>
      <DialogContent>
        <section className="hp-golf-notice-dialog__price" aria-label="9월 한정 할인 이용료">
          <span className="hp-golf-notice-dialog__price-label">
            <LocalOfferRoundedIcon aria-hidden="true" />9월 한정 월 이용료
          </span>
          <span className="hp-golf-notice-dialog__price-values">
            <del>20,000원</del>
            <strong>15,000원</strong>
          </span>
        </section>

        <div className="hp-golf-notice-dialog__items">
          <div className="hp-golf-notice-dialog__item">
            <span className="hp-golf-notice-dialog__icon" aria-hidden="true">
              <ConstructionRoundedIcon />
            </span>
            <div>
              <strong>9월 중 증설 공사 (9월 7일 ~ 17일 예상)</strong>
              <span>공사로 약 1주간 운영을 하지 않습니다.</span>
            </div>
          </div>
          <div className="hp-golf-notice-dialog__item">
            <span className="hp-golf-notice-dialog__icon" aria-hidden="true">
              <GolfCourseRoundedIcon />
            </span>
            <div>
              <strong>새 단장 후 더 편리하게</strong>
              <span>스크린 타석이 <strong>2개에서 5개로 확대</strong>되고, <strong>18시 이후 시간에는 연속 예약도 가능</strong>합니다.</span>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button className="hp-button hp-button--primary hp-golf-notice-dialog__confirm" onClick={handleConfirm} autoFocus>
          내용 확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GolfRenewalNoticeDialog;
